import Address from "../address";

export default function School(data) {
	let school = data || {};
    
	this.name = school.name;
	this.address = new Address(school.address);
}
